import React from 'react';

import { Menu } from 'antd';
import { RibbonButton } from 'common/components';
import { UploadOutlined } from '@ant-design/icons';
import { useGlobalModal } from 'hooks';

const ImportBulkProductOverlay = ({ disabled }) => {
  const { openModal, MODAL_NAMES } = useGlobalModal();

  const onClickImportButton = () => {
    openModal(MODAL_NAMES.IMPORT_BULK_PRODUCT_OVERLAY);
  };

  return (
    <Menu.Item style={{ backgroundColor: 'inherit' }}>
      <RibbonButton
        className='button-item-dropdown'
        icon={<UploadOutlined />}
        label={'Import Bulk Product Overlay'}
        size='small'
        disabled={disabled}
        onClick={onClickImportButton}
      />
    </Menu.Item>
  );
};

export default ImportBulkProductOverlay;
